module.exports = __webpack_public_path__ + "img/no-image.4fc222b2.jpg";